export default "__VITE_ASSET__53a20df0__"